var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCasino = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.093,
    height: 21.093,
    viewBox: "0 0 21.093 21.093",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "poker-piece-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_255",
    "data-name": "Trazado 255",
    d: "M17.4,2.535A10.547,10.547,0,1,0,18.559,17.4,10.495,10.495,0,0,0,17.4,2.535Zm2.044,11.072L16.225,12.5a6.023,6.023,0,0,0,0-3.893l3.22-1.108a9.474,9.474,0,0,1,0,6.113Zm.181-6.2h0Zm-1.99-3.03L15.073,6.6a6.056,6.056,0,0,0-.623-.617A5.974,5.974,0,0,0,11.7,4.656l.647-3.325a9.365,9.365,0,0,1,4.314,2.078A9.572,9.572,0,0,1,17.639,4.374ZM7.346,1.707a9.284,9.284,0,0,1,1.4-.383l.647,3.333A5.976,5.976,0,0,0,6.023,6.6L3.454,4.368A9.385,9.385,0,0,1,7.346,1.707Zm-5.7,5.781L4.868,8.6a6.024,6.024,0,0,0,0,3.893L1.644,13.6a9.482,9.482,0,0,1,0-6.113Zm1.8,9.237L6.02,14.491a6.044,6.044,0,0,0,.623.618,5.974,5.974,0,0,0,2.749,1.33l-.65,3.344a9.387,9.387,0,0,1-4.312-2.087A9.524,9.524,0,0,1,3.448,16.725Zm10.3,2.673a9.407,9.407,0,0,1-1.4.384L11.7,16.438a5.976,5.976,0,0,0,3.372-1.945l2.57,2.235A9.4,9.4,0,0,1,13.745,19.4Z",
    transform: "translate(0 -0.001)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 0.569,
    cy: 0.569,
    rx: 0.569,
    ry: 0.569,
    transform: "translate(6.074 3.237)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    cx: 0.569,
    cy: 0.569,
    rx: 0.569,
    ry: 0.569,
    transform: "translate(2.188 9.988)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    cx: 0.569,
    cy: 0.569,
    rx: 0.569,
    ry: 0.569,
    transform: "translate(6.092 16.728)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_21",
    "data-name": "Elipse 21",
    cx: 0.569,
    cy: 0.569,
    rx: 0.569,
    ry: 0.569,
    transform: "translate(13.881 16.717)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    cx: 0.569,
    cy: 0.569,
    rx: 0.569,
    ry: 0.569,
    transform: "translate(17.766 9.967)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_23",
    "data-name": "Elipse 23",
    cx: 0.569,
    cy: 0.569,
    rx: 0.569,
    ry: 0.569,
    transform: "translate(13.863 3.226)",
    fill: "#ffce05"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCasino);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/casino.5726d309370f9c3525972cd28e2db353.svg";